import { Button, Modal, Space } from "antd";
import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { useSelector } from "react-redux";
import NavigationPrompt from "./NavigationPrompt";
import objectIsEqual from "../utilities/objectIsEqual";
import translator from "../utilities/translator.js";
import { BackgroundColor } from "devextreme-react/cjs/chart.js";

function ChangeDetectionIcon({ hasChanged, moreLeft }) {
	const IconContainer = styled.div`
		color: #e78e4b;
		position: absolute;
		left: ${moreLeft ? "10px" : "20px"};
		font-size: 30px;
		top: 15px;
		z-index: 99999;
	`;

	if (hasChanged) {
		return (
			<IconContainer>
				<i className="fa fa-exclamation"></i>
			</IconContainer>
		);
	} else {
		return null;
	}
}

function ChangeDetectionComponent({
	initialValues,
	values,
	handleSubmit,
	moreLeft = false,
	showIcon = true,
	deepEqual = false,
}) {
	const currentLanguage = useSelector(
		(state) => state.session.userPreferences?.language
	);
	const history = useHistory();
	const [hasChanged, setHasChanged] = React.useState(false);

	React.useEffect(() => {
		const hasChanged = !objectIsEqual(initialValues, values);
		if (hasChanged) {
			setHasChanged(true);
		} else {
			setHasChanged(false);
		}
	}, [initialValues, values, deepEqual]);

	return (
		<>
			<NavigationPrompt when={hasChanged} history={history}>
				{(isOpen, onConfirm, onCancel) => (
					<Modal
						title={"You have unsaved changes!"}
						open={isOpen}
						zIndex={10000}
						width={600}
						centered
						onCancel={() => onCancel()}
						footer={
							<Space style={{ width: "100%", justifyContent: "flex-end" }}>
								<Button
									key="cancelandstay"
									type="primary"
									onClick={async () => {
										onCancel();
									}}
									style={{
										backgroundColor: "#656565",
										color: "#fff",
										border: "1px solid #d9d9d9",
									}}
								>
									Cancel and stay on the page
								</Button>

								<Button
									key="submit"
									type="primary"
									onClick={async () => {
										await handleSubmit();
										onConfirm();
									}}
									style={{
										backgroundColor: "#e78e4b",
										borderColor: "#e78e4b",
									}}
								>
									{translator(currentLanguage, "save")} changes and exit
								</Button>

								<Button
									key="cancelandgo"
									type="primary"
									onClick={async () => {
										onConfirm();
									}}
									style={{
										backgroundColor: "#ff4d4f",
										borderColor: "#ff4d4f",
										color: "#fff",
									}}
									onMouseEnter={(e) =>
										(e.currentTarget.style.backgroundColor = "#ff7875")
									}
									onMouseLeave={(e) =>
										(e.currentTarget.style.backgroundColor = "#ff4d4f")
									}
								>
									Exit without saving
								</Button>
							</Space>
						}
					>
						<p>
							You have unsaved changes in this form, would you like to save
							before you are redirected away? Choose option below:{" "}
						</p>
					</Modal>
				)}
			</NavigationPrompt>
			{showIcon && (
				<ChangeDetectionIcon hasChanged={hasChanged} moreLeft={moreLeft} />
			)}
		</>
	);
}

export default ChangeDetectionComponent;
